import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives';

export const MeasurementPriceSchema = oz.object({
  measurementId: ObjectIdSchema,
  price: oz.number().nonnegative(),
});

export type MeasurementPrice = oz.infer<typeof MeasurementPriceSchema>;